import useExperience from 'hooks/Experiences/useExperience'
import { useUserCartItemState } from './useUserCartItemState'
import { useEffect } from 'react'
import { useAppDispatch } from 'hooks/reduxHooks'
import { userCartItemsSaveForLater } from 'actions/AuthActions'
import { dateIsBeforeOrSame } from 'lib/datetime/dateUtils'
type UserCartTransferItemData = {
  experience: App.ExperienceOffer;
  loaded: true;
  loading: false;
  error: any;
  itemTotals: App.Checkout.ItemViewTotals;
  isDeleted: boolean;
  isSavedForLater: boolean;
  isBookable: boolean;
  isSoldOut: boolean;
  isPast: boolean;
} | {
  experience: App.ExperienceOffer | undefined;
  loaded: false;
  loading: boolean;
  error: any;
  itemTotals: App.Checkout.ItemViewTotals;
  isDeleted: boolean;
  isSavedForLater: boolean;
  isBookable: boolean;
  isSoldOut: boolean;
  isPast: boolean;
}

function useUserCartTransferItemData(item: App.Checkout.TransferItem): UserCartTransferItemData {
  const dispatch = useAppDispatch()
  const [experience, experienceLoading, experienceError] = useExperience(item.experienceId)
  const { isDeleted, isSavedForLater } = useUserCartItemState(item.itemId)

  const isSoldOut = !!experience && experience?.status !== 'ONLINE'
  const isPast = item.transfer.date ? dateIsBeforeOrSame(new Date(item.transfer.date), new Date()) : false
  const isBookable = experience?.status === 'ONLINE' && !experienceError && !isPast

  useEffect(() => {
    if (experience && !isBookable && !isSavedForLater && !experienceLoading && !isDeleted) {
      dispatch(userCartItemsSaveForLater([item.itemId]))
    }
  }, [isBookable, isSavedForLater, experienceLoading, dispatch, item.itemId, experience, isDeleted])

  const itemTotals: App.Checkout.ItemViewTotals = {
    price: item.transfer.option?.price ?? 0,
    memberPrice: 0,
    value: item.transfer.option?.price ?? 0,
    mobileAppDiscount: {
      amount: item.transfer.option?.discounts?.app.amount ?? 0,
      percentage: item.transfer.option?.discounts?.app.percentage ?? 0,
    },
    taxesAndFees: item.transfer.option?.taxesAndFees ?? 0,
    surcharge: 0,
    memberValue: 0,
    extraGuestSurcharge: 0,
  }

  const loading = experienceLoading
  const error = experienceError

  if (experience) {
    return {
      experience,
      loaded: true,
      loading: false,
      error,
      itemTotals,
      isDeleted,
      isSavedForLater,
      isBookable,
      isSoldOut,
      isPast,
    }
  } else {
    return {
      experience: undefined,
      loaded: false,
      loading,
      error,
      itemTotals,
      isDeleted,
      isSavedForLater,
      isBookable,
      isSoldOut,
      isPast,
    }
  }
}

export default useUserCartTransferItemData
